import { gql, useLazyQuery } from '@apollo/client';
import { CalculationInput, GetCalculationsQuery, QueryGetCalculationsArgs, SoTravelTravelData, TravelDataType } from '../types/types';

const GET_CALCULATION_QUERY = gql(`
query GetCalculations($input: CalculationInput!) {
  getCalculations(input: $input) {
    calculations {
      brandCode
      product {
        _id
        name
        brandId {
          _id
          code
          name
          shortName
        }
        productTypeSpecific {
          onlyPackage
          packageName
        }
      }
      includedCoverages {
        code
        variant
        label
        description
        variantInfo
        disabled
      }
      price {
        price
        discount
        totalPrice
      }
    }
    additionalCoverages {
      code
      description
      label
      isPopular
      variantType
      variants {
        code
        label
      }
    }
  }
}
`);

export function useGetCalculation() {
  const [getCalculations, { data, loading, error, refetch }] = useLazyQuery<GetCalculationsQuery, QueryGetCalculationsArgs>(GET_CALCULATION_QUERY);

    const fetchCalculations = (travelData: TravelDataType, includedCoverages?: Array<{ code: string; variant: string }>, contractor?: string) => {
      if (!travelData) {
        throw new Error('Travel data is required');
      }

      const transformedTravelData: SoTravelTravelData = {
        insuranceType: travelData.insuranceType,
        insuranceStartDate: travelData.insuranceStartDate,
        insuranceEndDate: travelData.insuranceEndDate || undefined,
        travelDestination: travelData.travelDestination,
        insuranceRange: travelData.insuranceRange,
        numOfInsuredAdults: travelData.numOfInsuredAdults,
        numOfInsuredChildren: travelData.numOfInsuredChildren,
        sportActivities: travelData.sportActivities,
        willWorkOnTrip: travelData.willWorkOnTrip,
        numOfInsuredPersons: travelData.numOfInsuredPersons,
        allInsuredPersonsAreFromTheSameFamily: travelData.allInsuredPersonsAreFromTheSameFamily,
        longestTripDuration: travelData.longestTripDuration || undefined,
        longestTripDurationDays: travelData.longestTripDurationDays || undefined,
        sportActivityCode: travelData.sportActivityCode || undefined,
        luggageValue: travelData.luggageValue || undefined,
        tripValue: travelData.tripValue || undefined,
      };
      
      const input: CalculationInput = {
        travelData: transformedTravelData,
        includedCoverages,
        contractor,
      };

      return getCalculations({ variables: { input } });
    };

  return {
    calculations: data?.getCalculations,
    loading,
    error,
    refetch,
    fetchCalculations
  };
}
